export const billingRoutesConfig = {
  main: `/billing`,
  internalRoutes: {},
} as const;
